import React from 'react'

import { Box, CircularProgress } from '@material-ui/core'

export const AppLoader =
  () =>
    <Box height={'100vh'} display={'flex'} flex={1} justifyContent={'center'} alignItems={'center'}>
      <CircularProgress color="secondary"/>
    </Box>